import { useI18n } from '@tribeplatform/react-components/i18n'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { BlockedMemberList } from './BlockedMemberList.js'

export const BlockedMembersSettings = () => {
  const { $t } = useI18n()

  return (
    <Card>
      <Card.Header
        title={$t({
          defaultMessage: 'Blocked members',
          id: 'Messaging.Settings.BlockedMembersTitle',
        })}
        description={$t({
          defaultMessage:
            'Here you can see and manage the members you’ve blocked. Unblock them at any time to restore messaging.',
          id: 'Messaging.Settings.BlockedMembersDescription',
        })}
      />
      <Card.Content>
        <BlockedMemberList />
      </Card.Content>
    </Card>
  )
}
